import React, {useCallback, useState, useEffect} from "react";
import $ from "jquery";
import { BottomScrollListener } from "react-bottom-scroll-listener";
import {debounce} from "lodash";
import I18n from 'i18n.js.erb'
import AddBlueprintImageToDataStructureFlowMenuSealed from "./AddBlueprintImageToDataStructureFlowMenuSealed";
import SwitchDisplay from "./SwitchDisplay";
import ErrorModal from "./ErrorModal";
import FullScreenLoadingOverlay from "./FullScreenLoadingOverlay";
import AlertPopup from "./AlertPopup";
import SealedProductBlockItem from "./SealedProductBlockItem";
import SealedProductListItem from "./SealedProductListItem";
import SealedProductTableItem from "./SealedProductTableItem";
import RequiredLoginAlertPopup from "./RequiredLoginAlertPopup";
import {
  SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE,
  handleBackPage,
  DESKTOP_WIDTH,
  IPAD_WIDTH,
  buildEditableSelect,
  onKeyDownQuantity,
  enterDownHandler,
  parseCategoryName,
  isDefined,
  parseLanguage
} from "../../utils/utils";

const IndexSealed = ({
     logged_in_user,
     game_id,
     blueprint_images,
     release_years,
     languages,
     categories,
     expansions,
     eras,
     sorting_options,
     sorting_directions,
     disable_marketplace
   }) => {

  const blueprintImages = JSON.parse(blueprint_images);
  const [initCompleted, setInitCompleted] = useState(false)
  const [blueprintImagesToRender, setBlueprintImagesToRender] = useState([]);
  const [allPluckedBlueprintImages, setAllPluckedBlueprintImages] = useState([]);
  const initialFilters = {
    name: null,
    category_id: null,
    era_id: null,
    expansion_id: null,
    released_at: null,
    language_filter: null,
    sort_by: 'sealed',
    sorting_direction: 'asc'
  }
  const [filters, setFilters] = useState(initialFilters);
  const [expansionsForFilter, setExpansionsForFilter] = useState(expansions)
  const [page, setPage] = useState(1);
  const [hasLoadedAllData, setHasLoadedAllData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadDataFromSessionStorage, setLoadDataFromSessionStorage] = useState(false);
  const [selectAll, setSelectAll] = useState(true);
  const [submited, setSubmited] = useState(false);
  const [orderingNumber, setOrderingNumber] = useState(1);
  const [globalQuantity, setGlobalQuantity] = useState(1);
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [showFullScreenLoadingOverlay, setShowFullScreenLoadingOverlay] = useState(false)
  const [showAlertPopupMyCollection, setShowAlertPopupMyCollection] = useState(false)
  const [showAlertPopupWishlist, setShowAlertPopupWishlist] = useState(false)
  const [ wishlistToNavigate, setWishlistToNavigate ] = useState(null)
  const [ showRequiredLoginModal, setShowRequiredLoginModal ] = useState(false);
  const [showAddToPopup, setShowAddToPopup] = useState(false)

  // console.log('blueprintImagesToRender: ', blueprintImagesToRender)
  // console.log('allPluckedBlueprintImages: ', allPluckedBlueprintImages)

  // Funzione che inizializza lo state che gestisce la tipologia della vista
  // sulla base del device utilizzato
  const initializeViewForProduct= () => {
    if (window.innerWidth >= DESKTOP_WIDTH) {
      return "block"
    } else if(window.innerWidth < IPAD_WIDTH) {
      return "block"
    }else{
      return "list"
    }
  }

  const [display, setDisplay] = useState(initializeViewForProduct());


  // Funzione che inizializza lo state che gestisce la tipologia della vista
  // sulla base del device utilizzato
  const initializeShowFiltersAndActions= () => {
    return window.innerWidth >= DESKTOP_WIDTH;
  }

  const [enableActionsMenu, setEnableActionsMenu] = useState(initializeShowFiltersAndActions())
  const [enableFilters, setEnableFilters] = useState(initializeShowFiltersAndActions())

  useEffect(() => {
    if (initCompleted && blueprintImagesToRender.length === 0) {
      getBlueprintImages();
    }
  }, [blueprintImagesToRender]);

  useEffect(() => {
    if (initCompleted && wishlistToNavigate) {
      setWishlistToNavigate(null)
      handleNavigation(null, null,`/wishlists/${wishlistToNavigate}/edit`)
    }
  }, [wishlistToNavigate]);

  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)

      let sealedProductsPrevData = sessionStorage.getItem(SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE);
      if (sealedProductsPrevData) {
        sealedProductsPrevData = JSON.parse(sealedProductsPrevData);
      }
      let sealedProductsCurrentUrl = `/games/${game_id}/sealed`;
      let functions = {
        setLoadDataFromSessionStorage: setLoadDataFromSessionStorage,
        setBlueprintImagesToRender: setBlueprintImagesToRender,
        setPage: setPage,
        setHasLoadedAllData: setHasLoadedAllData,
        setFilters: setFilters,
        setEnableFilters: setEnableFilters,
        setAllPluckedBlueprintImages: setAllPluckedBlueprintImages,
        setSelectAll: setSelectAll,
        setOrderingNumber: setOrderingNumber,
        setDisplay: setDisplay,
        setGlobalQuantity: setGlobalQuantity
      };
      if (sealedProductsPrevData && sealedProductsPrevData.url === sealedProductsCurrentUrl) {
        handleBackPage(SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE, sealedProductsPrevData, functions);
      } else {
        appendBlueprintImages(blueprintImages.blueprint_images_by_era)
        setAllPluckedBlueprintImages(blueprintImages.all_plucked_blueprint_images)
      }

      enterDownHandler(setEnableFilters)
    }
  }, []);


  useEffect(() => {
    if (filters.name) {
      debouncedUpdateFilterName();
      return debouncedUpdateFilterName.cancel;
    }
  }, [filters.name, debouncedUpdateFilterName]);

  useEffect(() => {
    if (filters.expansion_id)
      setTimeout(() => { $("span.select2-selection.select2-selection--single").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");
  }, [filters]);



  const handleChangeExpansionFilter = (e) => {
    getBlueprintImagesByMatchingFilters('expansion_id', e.target.value)
  }



  useEffect(() => {
    buildEditableSelect(handleChangeExpansionFilter)
  }, [ enableFilters, filters ]);


  // Funzione che permette di ottenere dal server nuovi prodotti sealed da renderizzare sull'interfaccia grafica
  const getBlueprintImages = () => {
    if (!hasLoadedAllData && !loadDataFromSessionStorage) {
      let url = `/games/${game_id}/sealed.json?page=${page}`;
      Object.entries(filters).forEach(([fieldName, fieldValue]) => {
        if (fieldValue !== null)
          url += `&${fieldName}=${fieldValue}`
      })

      fetch(url, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          setLoading(false)
          if (!page || page < 2)
            setAllPluckedBlueprintImages(data.all_plucked_blueprint_images)
          appendBlueprintImages(data.blueprint_images_by_era);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  };


  // Funzione che permette di concatenare le nuovi prodotti sealed ottenuti del server all'array che contiene tutti
  // i prodotti sealed da mostrare sull'interfaccia grafica all'utente
  const appendBlueprintImages = (newBlueprintImages) => {
    if (selectAll || !logged_in_user)
      setBlueprintImagesToRender(blueprintImagesToRender.concat(newBlueprintImages));
    else {
      const newBlueprintImagesToRender = [];

      newBlueprintImages.map((item) => {
        const newEra = {};

        Object.entries(item).map(([era, blueprintImagesByEra]) => {
          newEra[era] = blueprintImagesByEra.map((blueprintImage) => {
            const newBlueprintImage = {...blueprintImage}
            newBlueprintImage['quantity'] = globalQuantity
            newBlueprintImage['checked'] = isDefined(blueprintImage.encasing_id)
            return newBlueprintImage
          });
        });

        newBlueprintImagesToRender.push(newEra);
      });

      setBlueprintImagesToRender(blueprintImagesToRender.concat(newBlueprintImagesToRender));
    }

    setPage(page + 1);
    if (newBlueprintImages.length < 4)
      setHasLoadedAllData(true);
  };


  // Funzione che permette di ottenere dal server i prodotti sealed che matchano con i filtri
  // di ricerca specificati dall'utente sull'interfaccia grafica
  const getBlueprintImagesByMatchingFilters = (filter, value) => {
    const newFilters = {...filters}
    newFilters[filter] = value;
    if (filter === 'era_id')
      newFilters['expansion_id'] = null;
    updateFilters(newFilters)
  }


  //Funzione che esegue l'update debouncato di 1000 millisecondi del filtro di ricerca dei prodotti sealed per nome
  const debouncedUpdateFilterName = useCallback(
    debounce(() => updateFilters(filters), 1000),
    [filters.name]
  );


  //Funzione che setta il nuovo filtro di ricerca dei prodotti sealed per nome
  function onChangeFilterNameHandler(newFilterName) {
    const newFilters = {...filters}
    newFilters['name'] = newFilterName;
    setFilters(newFilters)
  }


  // Funzione che aggiorna le opzioni dal filtro di ricerca delle blueprintImages per espansioni quando l'utente
  // seleziona una specifica era per filtrarle
  const filterExpansions = (era_id) => {
    const filteredExpansions = expansions.filter(expansion => (expansion.era_id == era_id) || (!era_id || era_id === ""))
    setExpansionsForFilter(filteredExpansions)
  }


  // Funzione che aggiorna i filtri di ricerca dei prodotti sealed e rilancia
  // la ricerca su quelli che matchano con i nuovi filtri specificati
  const updateFilters = (newFilters) => {
    window.scrollTo(0, 0)
    setFilters(newFilters)
    setLoading(true)
    setPage(1)
    setHasLoadedAllData(false)
    setBlueprintImagesToRender([]);
    setAllPluckedBlueprintImages([])
    setSelectAll(true);
    setGlobalQuantity(1);
  }


  // Funzione che si occupa di resettare tutti i filtri di ricerca specificati dall'utente sull'interfaccia grafica
  const handleResetFilters = () => {
    $('.select2-custom').val('').trigger('change.select2');
    updateFilters(initialFilters);
    if (window.innerWidth <= IPAD_WIDTH)
      setEnableFilters(false)
  }


  // Funzione che gestisce la navigazione a una nuova pagina del sito, a partire da quella corrente
  const handleNavigation = (e, blueprintImage, newLocation) => {
    if (e)
      e.stopPropagation();

    const uncheckedBlueprintImages = [];
    blueprintImagesToRender.map((item) => {
      const newEra = {};

      Object.entries(item).map(([era, blueprintImagesByEra]) => {
        newEra[era] = blueprintImagesByEra.map((blueprintImage) => {
          return { ...blueprintImage, checked: false, quantity: null }
        });
      });

      uncheckedBlueprintImages.push(newEra);
    });

    const sealedProductsPrevData = {
      url: `/games/${game_id}/sealed`,
      page: page,
      hasLoadedAllData: hasLoadedAllData,
      filters: filters,
      blueprintImagesToRender: uncheckedBlueprintImages,
      display: display,
      enableFilters: enableFilters,
      allPluckedBlueprintImages: allPluckedBlueprintImages,
      selectAll: selectAll,
      orderingNumber: orderingNumber,
      scrollY: window.scrollY
    };
    sessionStorage.setItem("sealedProductsPrevData", JSON.stringify(sealedProductsPrevData));

    window.location = newLocation;
  };


  // Funzione che permette di cambiare la modalità di visualizzazione dei prodotti sealed da griglia a lista o viceversa
  const switchTab = (e) => {
    e.stopPropagation()
    if (e.target.id === "button-list") {
      setDisplay("list");
    } else if (e.target.id === "button-block") {
      setDisplay("block");
    } else {
      setDisplay("table");
    }
  };


  // Funzione che apre un pop up che chiede conferma all'utente circa la sua volontà di inserire nella sua
  // my collection / wishlist i prodotti sealed che ha selezionato sull'interfaccia grafica
  const openAlertPopup = (popupType) => {
    setShowAddToPopup(false)
    if(logged_in_user) {
      switch (popupType) {
        case 'wishList':
          setShowAlertPopupWishlist(true)
          break;
        case 'myCollection':
          setShowAlertPopupMyCollection(true)
          break;
      }
    }else{
      setShowRequiredLoginModal(true)
    }
  }


  // Funzione che permette all'utente di aggiungere i prodotti sealed
  // selezionati sull'interfaccia grafica alla sua My Collection
  const addProductsToMyCollectionHandler = () => {
    if (logged_in_user && atLeastOneSelectedCard()) {
      const myCollection = [];
      let globalQuantities = 0
      for (const item of blueprintImagesToRender) {
        for (const blueprintImage of item[Object.keys(item)[0]]) {
          if (blueprintImage.checked === true) {
            globalQuantities = globalQuantities + (blueprintImage.quantity ? blueprintImage.quantity : "1")
            myCollection.push({
              id: blueprintImage.id,
              blueprint_id: blueprintImage.blueprint_id,
              language: blueprintImage.language,
              quantity: blueprintImage.quantity ? blueprintImage.quantity : "1"
            });
          }
        }
      }

      setSubmited(true);
      // chiudo il menù delle azioni se sono su mobile
      if (window.innerWidth < DESKTOP_WIDTH) {
        setEnableActionsMenu(false)
      }
      if (globalQuantities > 30)
        setShowFullScreenLoadingOverlay(true)

      const url = "/my_collections";

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({game_id: game_id, items: myCollection}),
      })
        .then((res) => {
          setSubmited(false)
          setShowFullScreenLoadingOverlay(false)
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json();
        })
        .then((data) => {
          handleNavigation(null, null, `/my_collections/${data.id}/edit`)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  };


  // Funzione che permette all'utente di navigare alla pagina che renderizza tutte le offerte dei prodotti in vendita
  // relativamente ai prodotti sealed da lui selezionati sull'interfaccia grafica
  const viewOffersHandler = () => {
    if (atLeastOneSelectedCard()) {
      const blueprintImagesIds = [];

      for (const item of blueprintImagesToRender) {
        for (const blueprintImage of item[Object.keys(item)[0]]) {
          if (blueprintImage.checked === true)
            blueprintImagesIds.push(blueprintImage.id);
        }
      }

      if (blueprintImagesIds.length === 1)
        handleNavigation(null, null, `/products/${blueprintImagesIds[0]}`)
      else if (blueprintImagesIds.length > 1)
        handleNavigation(null, null, `/products?blueprint_images_ids=${blueprintImagesIds}`)
    } else {
      let marketplace_route = `/products?game_id=${game_id}&category_id=${filters.category_id ? filters.category_id : 'sealed'}`
      if (filters.name)
        marketplace_route = marketplace_route + `&name=${filters.name}`
      if (filters.era_id)
        marketplace_route = marketplace_route + `&era_id=${filters.era_id}`
      if (filters.expansion_id)
        marketplace_route = marketplace_route + `&expansion_id=${filters.expansion_id}`
      if (filters.language_filter)
        marketplace_route = marketplace_route + `&language_filter=${filters.language_filter}`
      handleNavigation(null, null, marketplace_route)
    }
  };


  // Funzione che permette all'utente di aggiungere i prodotti sealed selezionati sull'interfaccia grafica alla sua Wishlist
  const addProductsToWishlistHandler = () => {
    if (logged_in_user && atLeastOneSelectedCard()) {
      const wishList = [];
        for (const item of blueprintImagesToRender) {
        for (const blueprintImage of item[Object.keys(item)[0]]) {
          if (blueprintImage.checked === true)
            wishList.push(blueprintImage.id);
        }
      }

      setSubmited(true)
      // chiudo il menù delle azioni se sono su mobile
      if (window.innerWidth < DESKTOP_WIDTH) {
        setEnableActionsMenu(false)
      }
      if (wishList.length > 35)
        setShowFullScreenLoadingOverlay(true)

      const url = "/wishlists";

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({items: wishList}),
      })
        .then((res) => {
          setSubmited(false)
          setShowFullScreenLoadingOverlay(false)
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json();
        })
        .then((data) => {
          const newBlueprintImagesToRender = [];

          blueprintImagesToRender.map((item) => {
            const newEra = {};

            Object.entries(item).map(([era, blueprintImagesByEra]) => {
              newEra[era] = blueprintImagesByEra.map((blueprintImage) => {
                const newBlueprintImage = {...blueprintImage}
                if (blueprintImage.checked) {
                  newBlueprintImage['already_in_wishlist'] = data.id
                }
                return newBlueprintImage;
              });
            });

            newBlueprintImagesToRender.push(newEra);
          });

          setBlueprintImagesToRender(newBlueprintImagesToRender);
          setWishlistToNavigate(data.id)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  };


  // Funzione che permette di gestire la selezione di un nuovo prodotto sealed da aggiungere
  // alla my collection / wishlist dell'utente
  const onCheckHandler = (e, blueprintImageId) => {
    e.stopPropagation();
    const newBlueprintImagesToRender = [];

    blueprintImagesToRender.map((item) => {
      const newEra = {};

      Object.entries(item).map(([era, blueprintImagesByEra]) => {
        newEra[era] = blueprintImagesByEra.map((blueprintImage) => {
          if (blueprintImage.id === Number.parseInt(blueprintImageId, 10) && blueprintImage.encasing_id) {
            setOrderingNumber(orderingNumber + 1);
            return {
              ...blueprintImage,
              checked: blueprintImage.checked !== true,
              ordering_number: orderingNumber,
            };
          }
          return blueprintImage;
        });
      });

      newBlueprintImagesToRender.push(newEra);
    });

    setBlueprintImagesToRender(newBlueprintImagesToRender);

    if (allSelectedCards(newBlueprintImagesToRender)) {
      setSelectAll(false)
    } else {
      setSelectAll(true)
    }
  };


  // Funzione che verifica se tra i prodotti sealed fitlrati sull'interfaccia grafica,
  // ve n'è almeno uno selezionato dall'utente
  function atLeastOneSelectedCard() {
    for (const item of blueprintImagesToRender) {
      for (const blueprintImage of item[Object.keys(item)[0]]) {
        if (blueprintImage.checked)
          return true;
      }
    }
    return false;
  }


  // Funzione che verifica che i prodotti sealed filtrati sull'interfaccia grafica siano tutti selezionati dall'utente
  function allSelectedCards(newBlueprintImages) {
    for (const item of newBlueprintImages) {
      for (const blueprintImage of item[Object.keys(item)[0]]) {
        if (!blueprintImage.checked)
          return false;
      }
    }
    return true;
  }


  // Funzione che permette di selezionare / deselezionare TUTTI i prodotti sealed che matchano coi filtri di ricerca
  // specificati dall'utente alla sua my collection / wishlist
  const onMultipleSelectHandler = () => {
    setOrderingNumber(orderingNumber + 1);
    const newBlueprintImagesToRender = [];

    blueprintImagesToRender.map((item) => {
      const newEra = {};

      Object.entries(item).map(([era, blueprintImagesByEra]) => {
        newEra[era] = blueprintImagesByEra.map((blueprintImage) => {
          return {
            ...blueprintImage,
            checked: blueprintImage.encasing_id ? selectAll : false,
            ordering_number: blueprintImage["ordering_number"]
              ? blueprintImage["ordering_number"]
              : orderingNumber,
          };
        });
      });

      newBlueprintImagesToRender.push(newEra);
    });

    setBlueprintImagesToRender(newBlueprintImagesToRender);
    setSelectAll(!selectAll);
  };


  // Funzione che permette di aggiornare la quantità di copie di uno stesso prodotto sealed che l'utente vuole
  // aggiungere alla sua my collection
  const onChangeQuantity = (e, era_index, era_name, blueprint_image_index) => {

    if (e.target.value === '' || e.target.value >= 1) {
      const selectedEra = blueprintImagesToRender[era_index]
      const blueprintImagesbySelectedEra = selectedEra[era_name]
      const selectedBlueprintImage = blueprintImagesbySelectedEra[blueprint_image_index];

      const newBlueprintImagesToRender = [];

      blueprintImagesToRender.map((item) => {
        const newEra = {};

        Object.entries(item).map(([era, blueprintImagesByEra]) => {
          newEra[era] = blueprintImagesByEra.map((blueprintImage) => {
            if (blueprintImage.id === selectedBlueprintImage.id) {
              return {
                ...blueprintImage,
                quantity: e.target.value,
              }
            }
            return blueprintImage
          });
        });

        newBlueprintImagesToRender.push(newEra);
      });

      setBlueprintImagesToRender(newBlueprintImagesToRender);
    }
    e.stopPropagation()
  };


  // Funzione che permette di aggiornare la quantità di copie di TUTTI i prodotti sealed selezionati dall'utente
  // da aggiungere alla sua my collection
  const onChangeGlobalQuantity = (newQuantity) => {
    if (atLeastOneSelectedCard() && (newQuantity === '' || newQuantity > 0)) {

      const newBlueprintImagesToRender = [];

      blueprintImagesToRender.map((item) => {
        const newEra = {};

        Object.entries(item).map(([era, blueprintImagesByEra]) => {
          newEra[era] = blueprintImagesByEra.map((blueprintImage) => {
            const newBlueprintImage = {...blueprintImage}
            newBlueprintImage['quantity'] =
              newBlueprintImage.checked ? newQuantity : blueprintImage.quantity

            return newBlueprintImage
          });
        });

        newBlueprintImagesToRender.push(newEra);
      });

      setGlobalQuantity(newQuantity)
      setBlueprintImagesToRender(newBlueprintImagesToRender);
    }else if(!logged_in_user){
      setShowRequiredLoginModal(true)
    }
  };


  //converte l'array di bluprintImagesArray in una matrice con
  // coppie di elementi [[1,2] [3,4]... [n-1,n]]
  const getBluprintImagesInsideMatrix2Col = (bluprintImagesArray) => {
    let matrix = [], i, k;
    for (i = 0, k = -1; i < bluprintImagesArray.length; i++) {
      if (i % 2 === 0) {
        k++;
        matrix[k] = [];
      }
      matrix[k].push(bluprintImagesArray[i]);
    }
    return matrix;
  }

  //converte l'array di bluprintImagesArray in una matrice con
  // coppie di elementi [[1,2,3,4,5,6] [7,8,9,10,11,12]... [n-6,n-5,n-4,n-3,n-2,n-1,n]]
  const getBluprintImagesInsideMatrix6Col = (bluprintImagesArray) => {
    let matrix = [], i, k;
    for (i = 0, k = -1; i < bluprintImagesArray.length; i++) {
      if (i % 6 === 0) {
        k++;
        matrix[k] = [];
      }
      matrix[k].push(bluprintImagesArray[i]);
    }
    return matrix;
  }


  const add_margin_top = () =>{
    if(window.innerWidth>=DESKTOP_WIDTH){
       return 'mt-130px'
    }
    if(window.innerWidth<DESKTOP_WIDTH && (enableFilters || enableActionsMenu)){
      if(logged_in_user && enableActionsMenu){
        return 'mt-40px'
      }else{
        return ''
      }
    }else {
       return 'mt-20px'
    }
  }

  const setTopOfSwitchDisplay = () =>{

    if(enableFilters){
      if(window.innerWidth < DESKTOP_WIDTH){
        return '298px'
      }else{
        return '244px'
      }
    }else {
      if(enableActionsMenu && window.innerWidth < DESKTOP_WIDTH && window.innerWidth >= IPAD_WIDTH){
        if(!logged_in_user){
          return '328px'
        }else{
          return '378px'
        }

      }else{
        return '66px'
      }
    }

    // style={{ top: enableFilters ? (window.innerWidth < DESKTOP_WIDTH ? '298px' : '244px') : '72px' }}
  }


  return (
    <React.Fragment>
      {/*filtri*/}
      <React.Fragment>
        {
          !enableFilters ?
            <React.Fragment>
              <div
                className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) && 'icon--bg-active'} rounded-right show-on-desktop expansion__filter--mobile-position top-170px`}>
                <button type="button" className="btn p-7px" id="open_filter_panel"
                        onClick={(e) => setEnableFilters(true)}>
                  <i
                    className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`}/>
                </button>
              </div>


              {/*mobile button*/}
              <div
                className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) && 'icon--bg-active'} rounded-right show-on-mobile expansion__filter--mobile-position`}>
                <button type="button" className="btn p-7px"
                        onClick={(e) => setEnableFilters(true)}>
                  <i
                    className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`}/>
                </button>
              </div>
            </React.Fragment>
            :
            <React.Fragment>
              {
                enableFilters &&
                <div className="pl-4 pr-4 pb-2 filters-top-bar bg-light overflow-auto shadow"
                     id="filters">

                  <div className="row">
                    <div className="col-12 text-right p-lg-0">
                      <button type="button" className="btn p-0 mt-8px mr-4px" id="close_filter_panel"
                              onClick={(e) => setEnableFilters(false)}>
                        <i className="fas fa-times icon-close--size show-on-mobile"/>
                        <i className="fas fa-times icon-close--size show-on-desktop-imp"/>
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-2 col-md-3 col-6 mb-2">
                      <p className="mb-0">{I18n.t('js.filters.sort.cardName')}</p>
                      <input
                        type="text"
                        value={filters.name ? filters.name : ""}
                        className={`form-control ${filters.name ? 'border-aiG-blue-imp' : ''} rounded text--size-normal`}
                        placeholder={`${I18n.t('js.filters.name')}`}
                        id="name_filter"
                        onChange={(e) => e.target.value !== "" ? onChangeFilterNameHandler(e.target.value) : updateFilters({
                          ...filters,
                          name: ""
                        })}
                      />
                    </div>

                    <div className="col-lg-2 col-md-3 col-6 mb-2">
                      <p className="mb-0">{I18n.t('js.filters.category')}</p>
                      <select
                        className={`form-control ${filters.category_id ? 'border-aiG-blue-imp' : ''} rounded`}
                        value={filters.category_id ? filters.category_id : ""}
                        name="category_id_filter"
                        id="category_id_filter"
                        onChange={(e) => getBlueprintImagesByMatchingFilters('category_id', e.target.value)}
                      >
                        <option value={""}>{I18n.t('js.filters.category')}</option>
                        {categories.map((category) => (
                          <option value={category[1]} key={category[1]}>
                            { parseCategoryName(category[0]) }
                          </option>
                        ))}
                      </select>
                    </div>

                    {
                      eras && eras.length > 1 &&
                        <div className="col-lg-2 col-md-3 col-6 mb-2">
                          <p className="mb-0">{I18n.t('js.filters.sort.era')}</p>
                          <select
                            className={`form-control ${filters.era_id ? 'border-aiG-blue-imp' : ''} rounded`}
                            value={filters.era_id ? filters.era_id : ""}
                            name="era_filter"
                            id="era_filter"
                            onChange={(e) => {
                              filterExpansions(e.target.value);
                              getBlueprintImagesByMatchingFilters("era_id", e.target.value);
                            }}
                          >
                            <option value={""}>{I18n.t('js.filters.era')}</option>
                            {eras.map((era) => (
                              <option value={era.id} key={era.id}>
                                {era.name}
                              </option>
                            ))}
                          </select>
                        </div>
                    }

                    {
                      expansionsForFilter && expansionsForFilter.length > 1 &&
                        <div className="col-lg-2 col-md-3 col-6 mb-2">
                          <p className="mb-0">{I18n.t('js.filters.expansion')}</p>
                          <select
                            className="form-control select2-custom p-0"
                            value={filters.expansion_id ? filters.expansion_id : ""}
                            name="expansion_filter"
                            id="expansion_filter"
                            onChange={ (e) => {} }
                          >
                            <option value={""}>{I18n.t('js.filters.expansion')}</option>
                            {expansionsForFilter.map(expansion => {
                              return <option value={expansion.id} key={expansion.id} label={expansion.icon}>
                                {expansion.name}
                              </option>
                            })}
                          </select>
                        </div>
                    }

                    <div className="col-lg-2 col-md-3 col-6 mb-2">
                      <p className="mb-0">{I18n.t('js.filters.sort.releaseYear')}</p>
                      <select
                        className={`form-control ${filters.released_at ? 'border-aiG-blue-imp' : ''} rounded`}
                        value={filters.released_at ? filters.released_at : ""}
                        name="released_at_filter"
                        id="released_at_filter"
                        onChange={(e) => getBlueprintImagesByMatchingFilters('released_at', e.target.value)}
                      >
                        <option value={""}>{I18n.t('js.filters.releaseYear')}</option>
                        {release_years.map((release_year) => (
                          <option value={release_year[0]} key={release_year[0]}>
                            {release_year[0]}
                          </option>
                        ))}
                      </select>
                    </div>

                    {
                      languages && languages.length > 1 &&
                        <div className="col-lg-2 col-md-3 col-6 mb-2">
                          <p className="mb-0">{I18n.t('js.filters.sort.cardLanguage')}</p>
                          <select
                            className={`form-control ${filters.language_filter ? 'border-aiG-blue-imp' : ''} rounded`}
                            value={filters.language_filter ? filters.language_filter : ""}
                            name="language_filter"
                            id="language_filter"
                            onChange={(e) => getBlueprintImagesByMatchingFilters('language_filter', e.target.value)}
                          >
                            <option value={""}>{I18n.t('js.filters.sort.cardLanguage')}</option>
                            {languages.map((language) => (
                              <option value={language} key={language}>
                                {parseLanguage(language)}
                              </option>
                            ))}
                          </select>
                        </div>
                    }

                    <div className="col-lg-2 col-md-3 col-6 mb-2 d-flex justify-content-end align-items-end show-on-mobile">
                      <button
                        className="btn-standard-outline mt-3 pt-1 pb-1 btn-standard-outline-resized w-100"
                        onClick={handleResetFilters}>
                        {I18n.t('js.filters.resetFilter')}
                      </button>
                    </div>

                    <div className="col-lg-2 col-md-3 col-6 mb-2 d-flex justify-content-end align-items-end show-on-mobile">
                      <button
                        className="btn-standard bg-dark text-light mt-3 pt-1 pb-1 btn-standard-outline-resized w-100"
                        onClick={(e) => setEnableFilters(false)}>
                        {I18n.t('js.advancedSearch.filterComponent.search')}
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <p>{I18n.t('js.indexOrdersPage.sortBy')}</p>
                    </div>
                  </div>

                  <div className="row mt-minus-13px">
                    <div className=" col-xs-12 col-lg-4 d-flex justify-content-start align-items-center">
                      <select
                        className={`form-control ${filters.sort_by ? 'border-aiG-blue-imp' : ''} mr-1 p-0`}
                        name="sort_by" id="sort_by" value={filters.sort_by}
                        style={{minWidth: "60%"}}
                        onChange={(e) => getBlueprintImagesByMatchingFilters('sort_by', e.target.value)}>
                        {sorting_options.map((option, i) => {
                          return <option value={option.value}
                                         key={option.value + '_' + i}>{I18n.t(option.locale)}</option>
                        })}
                      </select>
                      <span>
                        <b>:</b>
                        </span>
                        <select
                          className={`form-control ${filters.sorting_direction ? 'border-aiG-blue-imp' : ''} ml-1 p-0`}
                          name="sorting_direction" id="sorting_direction"
                          value={filters.sorting_direction}
                          onChange={(e) => getBlueprintImagesByMatchingFilters('sorting_direction', e.target.value)}>
                          {sorting_directions.map(direction => {
                            return <option value={direction.value}
                                           key={direction.value}>{I18n.t(direction.locale)}</option>
                          })}
                        </select>
                    </div>

                    <div className="col-lg-2 mb-2 d-flex justify-content-end show-on-desktop-imp">
                      <button
                        className="btn-standard-outline mt-2 pt-1 pb-1 btn-standard-outline-resized w-100"
                        onClick={handleResetFilters}>
                        {I18n.t('js.filters.resetFilter')}
                      </button>
                    </div>
                  </div>
                </div>
              }
            </React.Fragment>
        }
      </React.Fragment>


      {
        loading ?
          <div className={`d-flex justify-content-center ${enableFilters ? 'mt-sealed-with-open-filter-menu' : 'mt-sealed-with-close-filter-menu' }`}>
            <div className="d-flex align-items-center mt-5">
              <div className="spinner-border" role="status"/>
              <b className="ml-2">{I18n.t('js.sealedPage.loadingProducts')}</b>
            </div>
          </div>
          :
          blueprintImagesToRender.length > 0 ?

            <div className={`${enableFilters ? 'mt-sealed-with-open-filter-menu' : enableActionsMenu ? 'mt-sealed-with-open-action-menu' : 'mt-sealed-with-close-filter-menu'} row w-100`}>
              <div id="elements-container container" className="col-lg-1 position-relative">
                <div className="w-90 m-auto">
                  <AddBlueprintImageToDataStructureFlowMenuSealed
                    logged_in_user={logged_in_user}
                    onMultipleSelectHandler={onMultipleSelectHandler}
                    selectAll={selectAll}
                    alertPopupHandler={openAlertPopup}
                    viewOffersHandler={viewOffersHandler}
                    filterVersions={[]}
                    setVersionFilter={() => {}}
                    versions={[]}
                    atLeastOnSelectedCard={atLeastOneSelectedCard()}
                    globalQuantity={globalQuantity}
                    onChangeGlobalQuantity={onChangeGlobalQuantity}
                    isEnableAction={enableActionsMenu}
                    setEnabledActions={setEnableActionsMenu}
                    disable_marketplace={disable_marketplace}
                  />
                </div>
              </div>

              <div id="elements-container container" className="col-lg-11">
                <div className="w-100 sealed-change-view-btn d-none d-md-block" style={{ top: setTopOfSwitchDisplay()}} >
                  <SwitchDisplay switchTab={switchTab}
                                 listTabColor={`${display === 'list' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                                 blockTabColor={`${display === 'block' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                                 tableTabColor={`${display === 'table' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                                 tableLayoutOnlyFor={'show-on-desktop-imp'}
                  />
                </div>

                <BottomScrollListener onBottom={getBlueprintImages}>
                  {blueprintImagesToRender.map((item, era_index) => {
                    return Object.entries(item).map(([era, blueprintImages]) => {
                      //fai funzione per capire se mettere o meno la classe mt-130
                      // return <div className={`${window.innerWidth>=IPAD_WIDTH && 'mt-130px'} row mb-130px-imp`} key={era}>
                      return <div className={`${add_margin_top()} row mb-130px-imp ${display !== 'table' ? 'border-aiG-black-imp' : ''}`} key={era}>
                        <div id={"era_name_" + era_index}
                          className="col-12 ml-auto title-eras text-night-blue text-center text-space mt-4">{era + ' ' + I18n.t('js.indexSealedPage.title')}</div>
                        <div id={"era_" + era_index + "_main_container"} className="col-12 position-relative p-0">
                          {
                            display === "list" &&
                            <div className="w-90 m-auto mt-10px">

                              {
                                getBluprintImagesInsideMatrix2Col(blueprintImages).map((matrixRowblueprintImage, rowindex) => (
                                  <div className="row m-auto" key={rowindex}>
                                    {
                                      matrixRowblueprintImage.map((blueprintImage, blueprint_image_index) => (
                                        <div className="col-lg-6 col-md-12" key={blueprint_image_index}>
                                          <SealedProductListItem
                                            key={blueprintImage.id}
                                            blueprintImage={blueprintImage}
                                            onCheckHandler={onCheckHandler}
                                            onKeyDownQuantity={onKeyDownQuantity}
                                            onChangeQuantity={onChangeQuantity}
                                            handleNavigation={handleNavigation}
                                            era_index={era_index}
                                            era_name={era}
                                            // blueprint_image_index è l'indice che identifica ogni carta univocamente.
                                            // La matrice utilizzata per mappare i dati è Nx2 quindi
                                            // ogni sua riga sarà formata da 2 colonne.
                                            // Poichè i deve essere univoco e il ciclo sulla matrice non
                                            // mi permette di avere un i univoco per ogni carta, con la
                                            // formula 2*rowindex+blueprint_image_index posso risalire a quale era l'indice della carta esaminata
                                            // all'interno dell'array blueprintImages ed avere così un indice univoco
                                            // per ognuna.
                                            blueprint_image_index={2*rowindex+blueprint_image_index}
                                            languages={languages}
                                          />
                                        </div>
                                      ))
                                    }
                                  </div>
                                ))}
                            </div>
                          }
                          {
                            display === "block" &&
                            <div className="w-90 m-auto mt-40px-imp">
                              {
                                getBluprintImagesInsideMatrix6Col(blueprintImages).map((matrixRowblueprintImage, rowindex) => (
                                  <div className="row pb-0 pb-lg-3 pt-3 mb-0 mb-lg-3 bg-white-on-desktop mr-md-3 ml-md-3 ml-lg-0 mr-lg-0" key={rowindex}>
                                    {
                                      matrixRowblueprintImage.map((blueprintImage, blueprint_image_index) => (
                                        <SealedProductBlockItem
                                          key={blueprintImage.id}
                                          blueprintImage={blueprintImage}
                                          onCheckHandler={onCheckHandler}
                                          onKeyDownQuantity={onKeyDownQuantity}
                                          onChangeQuantity={onChangeQuantity}
                                          handleNavigation={handleNavigation}
                                          era_index={era_index}
                                          era_name={era}
                                          // i è l'indice che identifica ogni carta univocamente.
                                          // La matrice utilizzata per mappare i dati è Nx6 quindi
                                          // ogni sua riga sarà formata da 2 colonne.
                                          // Poichè i deve essere univoco e il ciclo sulla matrice non
                                          // mi permette di avere un i univoco per ogni carta, con la
                                          // formula 2*rowindex+blueprint_image_index posso risalire a quale era l'indice della carta esaminata
                                          // all'interno dell'array blueprintImages ed avere così un indice univoco
                                          // per ognuna.
                                          blueprint_image_index={6*rowindex+blueprint_image_index}
                                          languages={languages}
                                        />
                                    ))}
                                  </div>
                                ))}
                            </div>
                          }
                          {
                            display === "table" &&
                            <div className="w-95 mt-40px-imp table-responsive">
                              <SealedProductTableItem
                                blueprintImages={blueprintImages}
                                handleNavigation={handleNavigation}
                                onKeyDownQuantity={onKeyDownQuantity}
                                onChangeQuantity={onChangeQuantity}
                                onCheckHandler={onCheckHandler}
                                era_index={era_index}
                                era_name={era}
                              />
                            </div>
                          }
                        </div>
                      </div>
                    });
                  })}
                  {
                    !hasLoadedAllData && !loadDataFromSessionStorage && blueprintImagesToRender.length > 0 &&
                    <div className="d-flex justify-content-center mb-5">
                      <div className="d-flex align-items-center">
                        <div className="spinner-border" role="status"/>
                        <b className="ml-2">{I18n.t('js.common.loading')}</b>
                      </div>
                    </div>
                  }
                </BottomScrollListener>
              </div>
            </div>
            :
            <div className={`${enableFilters ? 'mt-sealed-with-open-filter-menu': 'mt-sealed-with-close-filter-menu' } pt-5`}>
              <p
                className="text-space text-black-50 text--size-normal text-center text-bold">{I18n.t('js.filters.noResultsFound')}</p>
            </div>
      }

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />

      <FullScreenLoadingOverlay
        showFullScreenLoadingOverlay={showFullScreenLoadingOverlay}
        textFullScreenLoadingOverlay={`${I18n.t('js.indexCardPage.addingCardSpinner')}`}
      />


      {/*Alert per add in My collection*/}
      <AlertPopup
        showAlertPopup={showAlertPopupMyCollection}
        onSuccess={addProductsToMyCollectionHandler}
        onDiscard={setShowAlertPopupMyCollection}
        popupTitle={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyCollectionTitle')}`}
        popupContent={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMycollectionContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirmAdd').toUpperCase()}`}
      />

      {/*Alert per add in My wishlist*/}
      <AlertPopup
        showAlertPopup={showAlertPopupWishlist}
        onSuccess={addProductsToWishlistHandler}
        onDiscard={setShowAlertPopupWishlist}
        popupTitle={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyWishlistTitle')}`}
        popupContent={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyWishlistContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirmAdd').toUpperCase()}`}
      />

      <RequiredLoginAlertPopup
        showRequiredLoginAlertPopup={showRequiredLoginModal}
        onClose={setShowRequiredLoginModal}
      />
    </React.Fragment>
  );
}

export default IndexSealed;